import PageLayout from '../components/layout/PageLayout'
import HeroSection from '../components/sections/hero/HeroSection'
import AstrologersSection from '../components/sections/astrologers/AstrologersSection'
import LiveNowSection from '../components/sections/liveStream/LiveNowSection'
import ScheduleAppointmentSection from '../components/sections/appointment/ScheduleAppointmentSection'
import HowItWorksSection from '../components/sections/howItWorks/HowItWorksSection'
import PoojaSection from '../components/sections/poojas/PoojaSection'
import WhyChooseSection from '../components/sections/whyChoose/WhyChooseSection'
import GemstoneFinderSection from '../components/sections/gemstone/GemstoneFinderSection'
import MediaGallerySection from '../components/sections/gallery/MediaGallerySection'
import FreeHoroscopeSection from '../components/sections/horoscope/FreeHoroscopeSection'
import CoursesCatalogSection from '../components/sections/courses/CoursesCatalogSection'
import TestimonialsSection from '../components/sections/testimonials/TestimonialsSection'
import FaqSection from '../components/sections/faq/FaqSection'
import NewsletterSection from '../components/sections/newsletter/NewsletterSection'

export default function HomePage() {
  return (
    <PageLayout className="bg-[#403c3d]/5 text-[#151b21] antialiased min-h-screen flex flex-col">
      <main className="grow">
        <HeroSection />
        <LiveNowSection />
        <AstrologersSection />
        <ScheduleAppointmentSection />
        <HowItWorksSection />
        <PoojaSection />
        <WhyChooseSection />
        <GemstoneFinderSection />
        <MediaGallerySection />
        <FreeHoroscopeSection />
        <CoursesCatalogSection />
        <TestimonialsSection />
        <FaqSection />
        {/* <NewsletterSection /> */}
      </main>
    </PageLayout>
  )
}
